// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"_27fX5c1"};